import React from "react";
import { Navigate } from "react-router-dom";

/**
 * ProtectedAdminRoute
 * Matches the role-based tab access logic in AdminBottom.js (mobile) exactly.
 *
 * Usage:
 *   <Route path="/Webadmindashboard" element={
 *     <ProtectedAdminRoute allowedRoles={['admin', 'dashboard_view']}>
 *       <Admindashboard />
 *     </ProtectedAdminRoute>
 *   } />
 *
 * allowedRoles: array of role strings that can access this route.
 *   Pass null / omit to allow any authenticated user.
 */
export default function ProtectedAdminRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("authToken");

  // Not logged in → go to login
  if (!token) {
    return <Navigate to="/AdminLogin" replace />;
  }

  // Determine effective role (same logic as LeftNav.js and Webadminprofile.js)
  let effectiveRole = "admin";
  try {
    const userData = localStorage.getItem("user");
    if (userData) {
      const user = JSON.parse(userData);
      effectiveRole = user.permissions?.admin_user_type || user.role || "admin";
    } else {
      effectiveRole = localStorage.getItem("userRole") || "admin";
    }
  } catch {
    effectiveRole = localStorage.getItem("userRole") || "admin";
  }

  // If no role restriction, allow any authenticated user
  if (!allowedRoles) {
    return children;
  }

  // Check if current role is allowed
  if (allowedRoles.includes(effectiveRole)) {
    return children;
  }

  // Redirect to the user's own default landing page (matching mobile fallback logic)
  const defaultPageByRole = {
    customer_support: "/TaskScreenwebadmin",
    marketing: "/AdminPushNotification",
    dashboard_view: "/Webadmindashboard",
    accounts: "/adminbillingsummary",
    admin: "/Webadmindashboard",
  };

  const redirectTo = defaultPageByRole[effectiveRole] || "/Webadmindashboard";
  return <Navigate to={redirectTo} replace />;
}
